import React, { useEffect, useState, useRef } from 'react';
import { Spin } from 'antd'
import { IThemeSwiperRef, ThemeSwiper } from '@base/lib/ThemeSwiper';
import { ListProduct, listProductStyles, TListProductElement } from '@app/common/ListProduct';
import cn from 'classnames';
import { IProductDetailPopupProps, ProductDetailPopup } from '@app/common/ProductDetailPopup';
import { IListItemProduct } from 'mod/product-list/interface';
import { useTrans } from 'base/utils/i18n';
import type { ITabsItem } from 'mod/feature/interface';
import { getListPage } from 'mod/product-list/service';
import styles from './productLists.module.less';
import { ListProductProps as IOldListProductProps, ListProductProps } from '@base/snippets/ListProduct';
import { getVariantsByIds } from 'base/services/product-list';
import homeStyles from '@app/shop/index.module.less';

type IProps = {
    listLimit?: number;
    columnWidth?: number;
    tabItem?: ITabsItem;
    elements?: ListProductProps['elements'];
}

function transElements(elements: IOldListProductProps['elements']): TListProductElement[] {
    if (!elements) {
        return ['title', 'rate', 'prices', 'points', 'options'];
    }

    const map = {
        name: 'title',
        price: 'prices',
        flashsale: 'progress',
    };

    return elements.map(elem => map[elem] || elem)
}

export const ProductLists: React.FC<IProps> = (props) => {
    const swiperRef = useRef<IThemeSwiperRef>(null);
    const {
        listLimit = 10,
        tabItem,
    } = props

    let {
        columnWidth,
        elements = ['title', 'rate', 'prices', 'addCart']
    } = props

    columnWidth = !!columnWidth ? columnWidth : 280;

    const [variants, setVariants] = useState<IListItemProduct[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [productDetailPopupProps, setProductDetailPopupProps] = useState<IProductDetailPopupProps>({
        visible: false,
        onClose: () => setProductDetailPopupProps({ ...productDetailPopupProps, visible: false })
    })
    const { t } = useTrans();

    const {
        listSn,
        variants: variantIds = [],
    } = tabItem || {}

    const getVariantsByListSnHandle = async () => {
        try {
            setIsLoading(true);
            let res: any
            if (!!listSn) {
                res = await getListPage({
                    listSn: listSn || '',
                    pageSize: listLimit || 10,
                })
            } else {
                res = await getVariantsByIds({
                    variantIds: variantIds
                })
            }

            setVariants(res?.list || [])
        } catch (e) {
        } finally {
            setIsLoading(false)
        }
    }

    const pagination = true,
        navigation = true
    useEffect(() => {
        getVariantsByListSnHandle().then()
    }, [listSn, variantIds])

    return !variants.length ? null : (
        <div className={styles['product-list']}>
            <ProductDetailPopup {...productDetailPopupProps} />

            <Spin spinning={isLoading}>
                <ThemeSwiper
                    ref={swiperRef}
                    className={cn(
                        homeStyles.swiper,
                        'g-swiper-wrap',
                        { 'g-swiper-with-pagination': navigation && !pagination },
                        { 'g-swiper-with-both': navigation && pagination }
                    )}
                    slidesPerView={'auto'}
                    slidesPerGroup={1}
                    spaceBetween={20}
                    // centeredSlides
                    list={variants}
                    pagination={pagination}
                    navigation={navigation}
                    render={(item) => {
                        let _elements = transElements(elements) || [];

                        return (
                            <ListProduct
                                className={cn(styles.product, listProductStyles.product, 'g-product pointer')}
                                style={{ width: `${columnWidth}px` }}
                                item={item}
                                imageSize={columnWidth}
                                link={false}
                                elements={[..._elements]}
                                onClick={(product) => {
                                    setProductDetailPopupProps({
                                        ...productDetailPopupProps,
                                        visible: true,
                                        variantId: product.variantId,
                                    })
                                }}
                                addCart={{
                                    type: 'primary',
                                    icon: false,
                                    size: 'small',
                                    text: t('web_product_add_to_cart'),
                                    shape: 'round'
                                }}
                            />
                        )
                    }}
                />
            </Spin>
        </div>
    );
};